import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

//fill={props.color? props.color: "currentColor"}
export const ChevronUpIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} {...props} viewBox="0 0 10 6" ratio={10 / 6}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M9.76516 5.51516C9.61872 5.66161 9.38128 5.66161 9.23483 5.51516L5 1.28033L0.765165 5.51516C0.618718 5.66161 0.381282 5.66161 0.234834 5.51516C0.088388 5.36872 0.088388 5.13128 0.234834 4.98483L4.73484 0.484835C4.88128 0.338388 5.11872 0.338388 5.26516 0.484835L9.76516 4.98484C9.91161 5.13128 9.91161 5.36872 9.76516 5.51516Z"
                  fill={props.color? props.color: "currentColor"}/>

        </SvgIcon>
    )
}
